// extracted by mini-css-extract-plugin
module.exports = {"overlayBackground":"Background_overlayBackground__-kbbH"};